// extracted by mini-css-extract-plugin
module.exports = {"Frame":"Frame_Frame__3IgS3","exit":"Frame_exit__2K4IM","InFrame":"Frame_InFrame__wWzZ_","withToolbar":"Frame_withToolbar__1k02b"};